import { COLORS } from "../constants";

// The hue circle stepped by the golden angle keeps consecutive colours as far
// apart as a single pass can make them.
const GOLDEN_ANGLE = 137.508;

/**
 * Colour for the n-th story plotted on the readers/sessions chart.
 *
 * The palette only carries a dozen colours and an account can easily chart more
 * stories than that, so wrapping it (`COLORS[index % COLORS.length]`) handed the
 * 1st and the 13th story the exact same colour. That makes both the line and the
 * tooltip's colour dot useless for telling those two stories apart, which is the
 * whole point of the dot. Past the palette we generate colours instead.
 */
const getSeriesColor = (index: number) => {
  if (index < COLORS.length) return COLORS[index];

  const step = index - COLORS.length;
  const hue = Math.round((step * GOLDEN_ANGLE) % 360);
  // Alternating lightness so a generated hue that lands near a palette colour
  // still reads as a different colour.
  const lightness = step % 2 === 0 ? 45 : 68;

  return `hsl(${hue}, 70%, ${lightness}%)`;
};

export default getSeriesColor;
